import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/doc.svg'


const _hoisted_1 = { class: "pt-4 pb-4 mi-div" }
const _hoisted_2 = {
  key: 2,
  class: "content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Icon",
  class: "mt-2 mb-4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, " Upload file (JPG, JPEG, PNG, or PDF smaller than 10mb) ", -1)
const _hoisted_5 = {
  key: 0,
  class: "mt-2 v-messages",
  style: {"color":"red"}
}
const _hoisted_6 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "8",
          class: "text-center"
        }, {
          default: _withCtx(() => [
            (_ctx.url && !_ctx.isPdf)
              ? (_openBlock(), _createBlock(_component_v_img, {
                  key: 0,
                  src: _ctx.url,
                  height: "200"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (_ctx.url && _ctx.isPdf)
              ? (_openBlock(), _createBlock(_component_preview_pdf, {
                  key: 1,
                  "pdf-url": _ctx.url!
                }, null, 8, ["pdf-url"]))
              : _createCommentVNode("", true),
            (!_ctx.url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _hoisted_4,
                  _createVNode(_component_v_file_input, {
                    class: "content",
                    accept: ".pdf, image/*",
                    variant: "plain",
                    type: "file",
                    ref: "fileInputRef",
                    modelValue: _ctx.fileModel,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileModel) = $event)),
                    "prepend-icon": "",
                    "data-test": "file-input",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFileUrl($event))),
                    rules: _ctx.rules,
                    style: {"background-color":"transparent","border":"none","box-shadow":"none","width":"150px"}
                  }, null, 8, ["modelValue", "rules"]),
                  (_ctx.showSizeError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, " File size exceeds 10 MB "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          xs: "12",
          md: "4",
          class: "content mt-2 mb-2 d-flex align-center justify-center flex-column"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.click())),
                class: "mr-2 capitalize"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Choose file ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "primary",
                class: "capitalize",
                onClick: _ctx.clear
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Clear ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}